import * as React from 'react';
import { ClearButton } from '../../../../components/button/ClearButton';
import { EditCurrencyCell } from '../../../../components/tables/EditCurrencyCell';
import { EditSelectCell } from '../../../../components/tables/EditSelectCell';
import { EditTextCell } from '../../../../components/tables/EditTextCell';
import { CreditCategory } from '../../../../models/accounting/credit/credit-category';
import { CreditReason } from '../../../../models/accounting/credit/credit-reason';
import { CreditLineItem } from '../../../../models/accounting/credit/credit-request-lineitem';
import { CurrencyType } from '../../../../models/utilities/type-models';

// #region Component Props

interface IProps {
    onDataChange        : any;
    onDeleteRow         : any;
    lineItem            : CreditLineItem;
    errorItem           : any;
    idx                 : string;
    categories          : CreditCategory[];
    reasons             : CreditReason[];
    dealerCurrencyCode  : CurrencyType;
}

// #endregion

export const CreditLineItemEntryRow = (props: IProps) => {
    const { lineItem, idx, onDataChange, onDeleteRow, reasons, categories, dealerCurrencyCode } = props;
    let { errorItem } = props;

    if (!errorItem) {
        errorItem = {};
    }

    return <tr>
                <EditSelectCell
                    id={ idx }
                    name="reasonId"
                    value={ lineItem.reasonId }
                    error={ errorItem.reasonId }
                    classList=""
                    options={ reasons }
                    onChange={ onDataChange } />

                <EditSelectCell
                    id={ idx }
                    name="categoryId"
                    value={ lineItem.categoryId }
                    error={ errorItem.categoryId }
                    classList=""
                    options={ categories }
                    disabled={ lineItem.disabledCategory }
                    onChange={ onDataChange } />

                <EditTextCell
                    id={ idx }
                    name="description"
                    value={ lineItem.description }
                    error={ errorItem.description }
                    classList=""
                    type="text"
                    onChange={ onDataChange } />

                <EditCurrencyCell
                    id={ idx }
                    name="amount"
                    value={ lineItem.amount }
                    error={ errorItem.amount }     
                    currencyType={ dealerCurrencyCode }
                    showSymbol={true}           
                    classList=""
                    type="text"
                    onChange={ onDataChange } />

                <td className="editing-cell">
                    <ClearButton
                        text="Delete"
                        icon="la-trash" 
                        id={'creditlineitemdelete-' + idx }
                        onBtnClick={ (e: any) => onDeleteRow(idx, e) } />
                </td>
            </tr>;
};
